<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["labels", "data"],
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: "#a21c26",
            data: this.data,
          },
        ],
      },
      {
        legend: {
          display: false,
        },
        onClick: this.onChartClick,
      }
    );
  },
  methods: {
    onChartClick(point, event) {
      this.$emit("onBarClick", event[0]._index);
    },
  },
};
</script>
